export default {
    lang: "土耳其语",
    application: {
        name: 'Bilgi Yayın Sistemi',
    },
    ajaxTip: {
        success: 'Başarılı',
        error: 'Başarısız',
        noAccess: 'Bu kaynağa erişim izniniz yok',
        notFound: 'Erişilen kaynak bulunamadı',
        serverBusy: 'Sunucu meşgul',
        timeOut: 'Zaman aşımı',
    },
    menu: {
        home: 'Anasayfa',
        template: 'Şablon Yönetimi',
        program: 'Program Yönetimi',
        playplan: 'Oynatma Planı',
        device: 'Cihaz Yönetimi',
        "source-material": 'Malzeme Yönetimi',
        material: 'Malzeme',
        checkManage: 'Onay Yönetimi',
        setting: 'Ayarlar',
        usercenter: "Kullanıcı Merkezi",
        adminManage: "Cihaz Yönetimi",
        schedule: "Yapılacaklar Listesi",
        capitalassets: "Varlık Yönetimi",
        modifyPassword: "Şifreyi Değiştir",
        logout: "Çıkış Yap",
        "add": "Ekle",
        "edit": "Düzenle",
        "delete": "Sil",
        "view": "Görüntüle",
        "menu_1": "Anasayfa",
        "menu_2": "Cihaz Yönetimi",
        "menu_3": "Düzenle (Gelişmiş Ayarlar - Temel Düzenleme - Ağ Değiştir)",
        "menu_4": "Anlık Komutlar",
        "menu_5": "Düzenle (Bölüm Transferi)",
        "menu_6": "Strateji",
        "menu_7": "Ses Ayarları",
        "menu_8": "Parlaklık Ayarları",
        "menu_9": "İndirme Ayarları",
        "menu_10": "Uyku Ayarları",
        "menu_11": "Cihaz Özellikleri",
        "menu_12": "Düzenle/Ekle",
        "menu_13": "Program Yönetimi",
        "menu_14": "Yayın Geçmişi",
        "menu_15": "Sil (Toplu/Tekil)",
        "menu_16": "Yayınlanmakta Olan Programlar",
        "menu_17": "Gruplama",
        "menu_19": "Program Listesi",
        "menu_20": "İçerik Düzenleme",
        "menu_21": "Program Kopyala",
        "menu_23": "Program Yayınla",
        "menu_24": "Malzeme Yönetimi",
        "menu_25": "Yükle",
        "menu_28": "Hızlı Yayın",
        "menu_29": "Şablon Yönetimi",
        "menu_30": "Ortak Şablonlar",
        "menu_31": "Hemen Kullan",
        "menu_32": "Benim Şablonlarım",
        "menu_33": "Ortak Şablonlara Yayınla",
        "menu_35": "Paylaşım Geçmişi",
        "menu_36": "Denetim Yönetimi",
        "menu_37": "Program Denetimi",
        "menu_38": "Denetim (Onayla/Reddet)",
        "menu_39": "Malzeme Denetimi",
        "menu_41": "Denetim Geçmişi (Operatör)",
        "menu_42": "Denetim Geçmişi (Denetçi)",
        "menu_43": "Onay Sayısını Görüntüle",
        "menu_44": "Organizasyon Yönetimi",
        "menu_45": "Günlük Yönetimi",
        "menu_46": "Oynatma Günlükleri",
        "menu_47": "Yayın Günlükleri",
        "menu_48": "Hata Günlükleri",
        "menu_49": "Operasyon Günlükleri",
        "menu_50": "Dosya Günlükleri",
        "menu_51": "Giriş Günlükleri",
        "menu_52": "İçerik Onayı",
        "menu_53": "Depolama Alanı",
        "menu_54": "Organizasyon Yapısı",
        "menu_55": "Rol İzinleri",
        "menu_56": "Yetkilendirme",
        "menu_57": "Görüntüle (Yetkilendirme İzinleri)",
        "menu_58": "Organizasyon Üyeleri",
        "menu_60": "Alt Kullanıcı Şifrelerini Sıfırla",
        "menu_61": "Varlık Yönetimi",
        "menu_62": "Bakiyem",
        "menu_63": "Görüntüle (Fond Detayları)",
        "menu_64": "Veri Kullanımım",
        "menu_65": "Görüntüle (Veri Kullanım Detayları)",
        "menu_66": "Veri Kullanımı Satın Al",
        "menu_67": "Kapasitem",
        "menu_68": "Cihazlarım",
        "menu_69": "Sipariş Detayları",
        "menu_70": "Görüntüle (Yükle)",
        "menu_71": "Görüntüle (Satın Alınan Şablonlar)",
        "menu_72": "Görüntüle (Satın Alınan Veri Kullanımı)",
        "menu_73": "Diğer İzinler",
        "menu_74": "Görüntüle (Malzeme ve Program İstatistikleri)",
        "menu_75": "Görüntüle (Varlıklar)",
        "menu_76": "Görüntüle (Bulut Veri Kullanımı/İstatistikleri)",
        "menu_77": "Görüntüle (Çevrimiçi Cihaz İstatistikleri)"
    },
    login: {
        terminalServiceSystem: 'Akıllı Terminal Hizmet Sistemi',
        accountLogin: 'Hesap Girişi',
        register: 'Kayıt Ol',
        accountLoginTip: 'Zaten bir hesabınız varsa giriş yapın',
        scanQRCode: 'Lütfen QR kodunu tarayın',
        readAndAgree: 'Okudum ve kabul ediyorum',
        readAndAgreeLink: 'Kullanıcı Hizmet Sözleşmesi',
        readAndAgreeAgreement: 'Lütfen kullanıcı hizmet sözleşmesini okuyun ve kabul edin',
        forgetpassword: "Şifrenizi mi unuttunuz？",
        resetpassword: "Şifreyi Sıfırla",
        phoneEmptyTip: "Lütfen cep telefonu numarasını girin",
        nextStep: "Sonraki Adım",
        title: 'Girişe Hoş Geldiniz',
        submit: 'Giriş Yap',
        userName: 'Hesap',
        password: 'Şifre',
        userNameEmptyTip: 'Lütfen hesap girin',
        passwordEmptyTip: 'Lütfen şifre girin',
        passwordFormatTip: 'Lütfen doğru şifre formatını girin',
        passwordIsOk: 'Lütfen onay şifresini girin',
        passwordSign: 'Lütfen şifre girin',
        codeTip: "Lütfen doğrulama kodunu girin",
        phone: "Cep telefonu numarası boş olamaz",
        code: "Doğrulama kodu boş olamaz",
        nickname: "Şirket adı boş olamaz",
        pass: "Şifre boş olamaz",
        pwdMessage: "Şifre 8~20 karakter uzunluğunda olmalıdır, boşluk içermemeli ve büyük harf, küçük harf, rakam, özel karakterlerden üçünü içermelidir",
        pwdMessage01: "Lütfen sekiz haneden fazla harf ve rakam组合的 şifre girin",
        pwdMessage02: "Şifre 8-20 karakter uzunluğunda olmalıdır",
        pwdMessage03: "Şifre boşluk içermemelidir",
        pwdMessage04: "Şifre büyük harf, küçük harf, rakam, sembolden üçünü içermelidir",
        newpassempty: "Yeni şifre boş olamaz",
        newpass: "İki şifre uyuşmuyor",
        getcode: "Doğrulama Kodu Al",
        format: "Cep telefonu numarası formatı不正确",
        chongfa: "saniye sonra tekrar gönder",
        isSend: 'Gönderildi',
        noregister: "Hesabınız yok mu？Hemen kayıt olun",
        Mobile: "Cep Telefonu Numarası",
        verificationcode: "Doğrulama Kodu",
        petname: "Takma Ad",
        Quickregistration: "Hızlı Kayıt",
        xiugaimima: "Şifreyi Değiştir",
        jiumima: "Eski Şifre",
        xinmima: "Yeni Şifre",
        zaicishuruxinmima: "Yeni Şifreyi Tekrar Girin",
        xiugaichenggong: "Değiştirme Başarılı",
        xiugaishoujihao: "Cep Telefonu Numarasını Değiştir",
        dengluzhanghao: "Giriş Hesabı",
        gongsiid: "Şirket ID",
        yonghunicheng: "Kullanıcı Takma Adı",
        chuangjianshijian: "Oluşturulma Zamanı",
        gongsimingcheng: "Şirket Adı",
        denglumima: "Giriş Şifresi",
        jianyi: "Harf ve rakam组合的 şifre kullanmanız önerilir",
        shezhimima: "Şifre Ayarla",
        shezhishoujihao: "Cep Telefonu Numarasını Değiştir/Ayarla",
        yibangding: "Bağlandı",
        weibangding: "Bağlanmadı",
        zhanghuanquan: "Hesap Güvenliği",
        yonghuxinxi: "Kullanıcı Bilgileri",
        zhuceSucMsg: 'Tebrikler,kayıt başarılı!',
        verificationcodeSucMsg: "Doğrulama kodu gönderildi başarıyla！",
        requiredIsEmpty: "Zorunlu alanlar boş olamaz！",
        emailObj: {
            title: 'E-posta',
            tit: 'E-posta Girişi',
            tip: 'Lütfen e-posta adresini girin',
            formatTip: 'Lütfen doğru e-posta formatını girin',
        },
        phoneObj: {
            title: 'Cep Telefonu Numarası',
            tit: 'Cep Telefonu Girişi',
            tip: 'Lütfen cep telefonu numarasını girin',
            formatTip: 'Lütfen doğru cep telefonu numarası formatını girin',
        },
        emailOrPhoneObj: {
            title: 'E-posta veya Cep Telefonu Numarası',
            tit: 'E-posta veya Cep Telefonu Girişi',
            tip: 'Lütfen e-posta veya cep telefonu numarasını girin',
            formatTip: 'Lütfen doğru e-posta veya cep telefonu numarası formatını girin',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'WeChat Girişi',
        },
        googleObj: {
            title: 'Google',
            tit: 'Google Girişi',
        },
        confirm: 'Onayla',
        confirmSubmit: 'Onayla ve Gönder',
        cancel: 'İptal',
        close: 'Kapat',
        bindSucMsg: 'Bağlama başarılı',
        toContinueBindAccount: 'Üçüncü parti hesap bağlamasını tamamlamak için devam edin',
        bindTip01: 'Hesabınız yok mu？Bir tane kaydedin',
        bindTip02: 'Zaten bir hesabınız var',
        bindTip03: 'Mevcut üçüncü parti hesap platform hesabına bağlı değil, lütfen mevcut hesaba bağlayın veya yeni bir hesap kaydedip bağlayın, bir dahaki sefere hızlı giriş yapabilirsiniz.',
        bindTip04: 'Mevcut Hesaba Bağla',
        bindTip05: 'Yeni Hesap Kaydedip Bağla',
        bindTip06: 'Üçüncü parti yetkilendirmeyi tamamladınız, aşağıdaki giriş bilgilerini tamamlayarak bağlamayı bitirebilirsiniz',
        bindSubmit: 'Bağlamayı Gönder',
        enterAccountTip: 'Lütfen hesap adını girin',
        RegisterAndBind: 'Kaydet ve Bağla',
        loginErr: 'Kullanıcı adı veya şifre hatalı！',
        usercenter: "Kullanıcı Merkezi",
        pleaseInputName: "Lütfen adını girin",
        operationSuccess: "İşlem başarılı！",
        edit: "Düzenle",
        xiugai: "Değiştir",
        userData: "Kişisel Bilgiler",
        changePassword: "Şifreyi Değiştir",
        account: "Hesap",
        userName01: "Kullanıcı Adı",
        phoneNumber: "Cep Telefonu Numarası",
        role: "Rol",
        createTime: "Oluşturulma Zamanı",
        genghuang: "Değiştir",
        bangding: "Bağla",
        unbind: "Bağlantıyı Kaldır",
        plesaseSelectBindingType: "Lütfen bağlama türünü seçin",
        pleaseConfirmCont: "Bu içeriği okuduğumu onaylayın lütfen",
        confirmReadCont: "Bu içeriği okudum",
        frequentTip: "İşlem çok sık,lütfen daha sonra tekrar deneyin!",
        zhuxiaoBtn: "Hesabı İptal Et",
        zhuxiaoTitle: "Hesap İptali",
        querenZhuxiao: "İptali Onayla",
        jiXu: "Devam Et",
        sendCodeBtn: "Doğrulama Kodu Gönder",
        passwordIsNotOldPassword: "Onay şifresi yeni şifre ile farklı",
        passwordIsOldPassword: "Değiştirilen şifre eski şifre ile aynı",
        passFormatError: "Lütfen doğru şifre formatını girin",
        oldPassWord: "Eski Şifre",
        newPassWord: "Yeni Şifre",
        inputPlaceholder: 'Lütfen girin',
        confirmPassword: "Şifreyi Onayla",
        zhuxiaoTip: `
            1、Hesap iptali geri alınamaz bir işlemdir, hesap bir kere iptal edildikten sonra bu hesapla veya bu hesapla kaydedilen üçüncü parti hesaplarla artık giriş yapıp kullanamazsınız, lütfen hesapla ilgili tüm bilgileri ve verileri kendi başınıza yedekleyin.
            2、Bu hesabı kaydetmeden önce, tüm varlıkları boşalttığınızı ve herhangi bir anlaşmazlığın olmadığını mutlaka onaylayın; bu hesap bir kere iptal edildikten sonra, hesap içindeki tüm varlıkların ve hakların sahipliğini feragat ettiğiniz kabul edilir ve geri alınamaz veya bulunamaz.
            3、Aynı cep telefonu numarası ile kaydedilen hesaplar toplamda 3 kez iptal edildikten sonra, bu cep telefonu numarası ile artık yeni hesap kaydedilemez ve aynı zamanda herhangi başka hesaba da bağlanamaz.
        `
    },
    home: {
        title: "Anasayfa",
        quickOperation: "Hızlı İşlemler",
        addDevice: "Cihaz Ekle",
        publishProgram: "Program Yayınla",
        publishMaterial: "Malzeme Yayınla",
        makeProgram: "Program Oluştur",
        uploadMaterial: "Malzeme Yükle",
        todayData: "Bugün Verileri (Her saat güncellenir)",
        playNumChart: "Oynatma Sayısı İstatistiği",
        deviceOnlineStatus: "Cihaz Çevrimiçi Durumu",
        onLineDevice: "Çevrimiçi Cihazlar",
        unLineDevice: "Çevrimdışı Cihazlar",
        programPlayTime: "Program Oynatma Süresi İstatistiği",
        downloadSoft: "Yazılım İndir",
        adminApp: "Mobil Kullanıcı Uygulaması",
        playerApp: "Bilgi Yayın Oynatma Terminali",
        downloadAdminApp: "Kullanıcı uygulamasını indirmek için tıklayın",
        downloadPlayerApp: "Oynatma uygulamasını indirmek için tıklayın",
        aboutUs: "Hakkımızda",
        userManual: "Kullanıcı Kılavuzu",
        message: "Mesaj Göndermek İstiyorum",
    },
    device: {
        inputPlaceholder: 'Lütfen girin',
        selectPlaceholder: 'Lütfen seçin',
        osTypeStr: 'Terminal Sistemi',
        onLineStatus: 'Çevrimiçi Durum',
        dpi: 'Çözünürlük',
        companyDeptIdName: 'İlişkili Kurum',
        deviceGroupIdName: 'İlişkili Grup',
        editOrMove: 'Düzenle/Taşı',
        loanOriginationFee: 'Kredi İşlem Ücreti',
        strategyInfoLook: 'Strateji Bilgilerini Görüntüle',
        programLook: 'Programları Görüntüle',
        addEquipments: 'Cihaz Ekle',
        luminanceSet: 'Parlaklık Kontrolü',
        terminal: 'Terminal Ayarları',
        transferCompany: 'Departmana Aktar',
        releasedProgram: 'Program Yayınla',
        screenshot: 'Ekran Görüntüsü Al',
        changeGroup: 'Grubu Değiştir',
        defaultGroup: "Varsayılan Grup",
        operation: "İşlem",
        edit: "Düzenle",
        saveEdit: "Düzenlemeyi Kaydet",
        add: "Ekle",
        save: "Kaydet",
        setting: "Ayarla",
        program: "Program",
        unbind: "Bağlantıyı Kaldır",
        sleep: "Uyku Moduna Al",
        wakeup: "Uyandır",
        restart: "Yeniden Başlat",
        shutdown: "Kapat",
        reportLog: "Günlüğü Bildir",
        clearPlayData: "Oynatma terminali verilerini temizle",
        offlineWarn: "Bu cihaz çevrimdışı, lütfen cihaz çevrimiçi olduktan sonra tekrar deneyin！",
        confirmUnbind: "Bağlantıyı kaldırmayı onayla",
        confirmReset: "Sıfırlamayı onayla",
        confirmDelete: "Silmeyi onayla",
        delete: "Sil",
        cancelDelete: "Silmeyi İptal Et",
        confirmResetSuccess: "Temizleme başarılı",
        confirm: "Onayla",
        cancel: "İptal",
        operationSuccess: "İşlem başarılı",
        unbindSuccess: "Bağlantı kaldırma başarılı",
        pleaseSelectDevice: "Lütfen cihaz seçin",
        pleaseSelectOnlineDevice: "Lütfen çevrimiçi cihaz seçin",
        confirmMixOperation: "Seçilen cihazlar arasında çevrimdışı cihazlar bulunuyor, bu ayar çevrimdışı cihazlar için geçerli değil, işlemi devam ettirmeyi onaylıyor musunuz？",
        pleaseSelectDate: "Lütfen tarih seçin",
        reportSuccess: "Bildirim başarılı",
        deviceSetting: "Cihaz Ayarları",
        default: "Varsayılan",
        all: "Tümü",
        deviceList: "Cihaz Listesi",
        addDevice: "Cihaz Ekle",
        department: "Departman Kurumu",
        deviceType: "Çözünürlük",
        osType: "Terminal Sistemi",
        onlineState: "Çevrimiçi Durum",
        online: "Çevrimiçi",
        offline: "Çevrimdışı",
        notActive: "Aktif Değil",
        search: "Lütfen anahtar kelime girin",
        batchOperation: "Toplu İşlem",
        allDevices: "Tüm Cihazlar",
        deviceAttribute: "Cihaz Özellikleri",
        selectReportDate: "Bildirim tarihini seçin",
        inputName: "Lütfen adını girin",
        inputWidth: "Lütfen genişliği girin",
        inputHeight: "Lütfen yüksekliği girin",
        inputResolutionRatio: "Lütfen 0'dan büyük bir tam sayı girin！",
        inputSort: "Lütfen sıralamayı girin",
        serialNum: "Sıra Numarası",
        name: "Adı",
        width: "Genişlik",
        height: "Yükseklik",
        resolutionRatio: "Çözünürlük",
        inputResolutionRatioName: "Lütfen çözünürlük adını girin",
        sort: "Sıralama",
        personal: "Kişisel",
        system: "Sistem",
        type: "Tür",
        systemDefaultSettingUneditable: "Sistem varsayılan ayarları düzenlenemez!",
        systemDefaultSettingUnDeletable: "Sistem varsayılan ayarları silinemez!",
        newz: "Yeni Ekle",
        total: "Toplam",
        totalNum: "adet",
        strategyName: "Strateji Adı",
        associatedTerminalNum: "İlişkili Terminal Sayısı",
        createTime: "Oluşturulma Zamanı",
        pleaseSelectStrategy: "Lütfen strateji seçin！",
        onlySelectOneData: "Sadece bir veri seçilebilir！",
        downloadStrategy: "Stratejiyi İndir",
        inputStrategyName: "Lütfen strateji adını girin",
        luminanceControl: "Parlaklık Kontrolü",
        volumeStrategy: "Ses Seviyesi Stratejisi",
        saveSuccess: "Kaydetme başarılı",
        screenAngle: "Ekran Döndürme(°)",
        startTime: "Başlangıç Zamanı",
        endTime: "Bitiş Zamanı",
        repeat: "Tekrarla",
        monday: "Pazartesi",
        tuesday: "Salı",
        wednesday: "Çarşamba",
        thursday: "Perşembe",
        friday: "Cuma",
        saturday: "Cumartesi",
        sunday: "Pazar",
        everyday: "Her Gün",
        downloadSpeed: "İndirme Hızı",
        inputDownloadSpeed: "Lütfen indirme hızını girin",
        operator: "İşlem",
        pleaseSelectDeleteData: "Lütfen silinecek verileri seçin！",
        confirmBatchDelete: "Toplu silmeyi onaylıyor musunuz？",
        pleaseInputName: "Lütfen adını girin",
        detailSetting: "Detaylı Ayarlar",
        weekPlan: "Haftalık Plan",
        specialDateSetting: "Özel Tarih Ayarları",
        weekdayInfo: "Hafta günü zorunlu bir seçenektir!",
        volumeInfo: "Ses seviyesi zorunlu bir seçenektir!",
        timeError: "Zaman seçimi hatası!",
        editSuccess: "Düzenleme işlemi başarılı！",
        addSuccess: "Ekleme işlemi başarılı！",
        addSpecialPlan: "Özel strateji planı ekle",
        downloadSpeedInfo: "İndirme Hızı:(0 indirmeyi engellemeyi temsil eder)",
        pleaseSelectStartTime: "Lütfen başlangıç zamanını seçin",
        pleaseSelectEndTime: "Lütfen bitiş zamanını seçin",
        luminanceError: "Lütfen doğru parlaklık değerini girin！",
        defaultLuminance: "Varsayılan Parlaklık",
        luminance: "Parlaklık Büyüklüğü",
        defaultLuminanceInfo: "Varsayılan Parlaklık(100 en parlak,0 en karanlık)",
        volume: "Ses Seviyesi",
        saveLuminance: "Parlaklığı Kaydet",
        changeSuccess: "Değiştirme başarılı！",
        changeNetwork: "Ağı Değiştir",
        netName: "Ağ Adı",
        nameempty: "Ağ adı boş olamaz",
        currentNetwork: "Mevcut Ağ",
        ipAddress: "IP Adresi",
        dailyMode: "Günlük Mod",
        weeklyMode: "Haftalık Mod",
        turnOnTime: "Açılma Zamanı",
        turnOffTime: "Kapanma Zamanı",
        startSleep: "Uyku Moduna Giriş",
        endSleep: "Uyku Modundan Çıkış",
        batchDelInfo: "Seçilen öğeleri silmeyi onaylıyor musunuz？",
        timeCannotBeEmpty: "Zaman boş olamaz!",
        startUp: "Aç",
        shutDown: "Kapat",
        volumeSize: "Ses Seviyesi Büyüklüğü",
        defaultVolume: "Varsayılan Ses Seviyesi(100 en yüksek,0 sessiz)",
        chooseStartTime: "Lütfen başlangıç zamanını seçin",
        chooseEndTime: "Lütfen bitiş zamanını seçin",
        saveVolume: "Ses Seviyesini Kaydet",
        screenRotationUnSaved: "Ekran döndürme kaydedilmedi",
        volumeSettingUnSaved: "Ses seviyesi ayarı kaydedilmedi",
        luminanceSettingUnSaved: "Parlaklık ayarı kaydedilmedi",
        confirmClosePopup: "Bu açılır pencereyi kapatmayı onaylıyor musunuz?",
        volumeSettingSuccess: "Ses seviyesi değiştirme başarılı",
        luminanceSettingSuccess: "Parlaklık ayarı değiştirme başarılı",
        advancedSettingUnSaved: "Gelişmiş ayarlar kaydedilmedi",
        settingTitle: "Terminal Ayarları",
        volumeSetting: "Ses Seviyesi Ayarları",
        luminanceSetting: "Parlaklık Ayarları",
        downloadSetting: "İndirme Ayarları",
        sleepSetting: "Uyku Ayarları",
        onOffSetting: "Zamanlı Açma/Kapama",
        screenRotation: "Ekran Döndürme",
        namingError: "Adlandırma hatası, dosya adında boşluk olamaz！",
        deleteSuccess: "Silme başarılı",
        deleteFolder: "Klasörü Sil",
        pleaseInputDeviceName: "Lütfen cihaz adını girin",
        pleaseInputDeviceId: "Lütfen cihaz kimliğini girin",
        discoverDevice: "Cihazı Bul",
        deviceId: "Cihaz ID",
        bound: "Bağlandı",
        bind: "Bağla",
        noDevice: "Cihaz yok",
        refresh: "Yenile",
        manualAdd: "Elle Ekle",
        deviceGroup: "Cihaz Sınıflandırması",
        pleaseSelectGroup: "Lütfen grup seçin！",
        deviceName: "Cihaz Adı",
        goAdd: "Eklemeye Git",
        close: "Kapat",
        bindCountInsufficient: "Bağlanabilen sayı yetersiz, lütfen cihaz sayısını yükselterek ekleyin！",
        displayNumber: "Görüntüleme Numarası",
        groupName: "Grup Adı",
        pleaseSelectGroupName: "Lütfen grup adını doldurun！",
        moveGroup: "Grubu Taşı",
        longitude: "Boylam",
        latitude: "Enlem",
        nationality: "Ulusallık",
        province: "İl",
        city: "İlçe",
        county: "Köy/Belde",
        outNetIp: "Harici Ağ IP",
        inNetIp: "İç Ağ IP",
        companyName: "Şirket Adı",
        Info: "Detaylar",
        android: "Android",
        win: "Windows",
        osVersion: "Sistem Sürümü",
        softwareVersion: "Yazılım Sürümü",
        diskSize: "Disk Boyutu",
        useSize: "Kullanılan Boyut",
        macAddr: "MAC Adresi",
        longitudeLatitudeInfo: "Boylam ve enlem aynı anda boş veya dolu olmalıdır!",
        terminalName: "Terminal Adı",
        terminalGroup: "Terminal Grubu",
        reportJournal: "Bildirimi Yapılıp Yapılmayacağı",
        systemVersion: "Sistem Sürümü",
        storageSpace: "Depolama Alanı",
        resolution: "Çözünürlük",
        runningMemory: "Çalışma Belleği",
        model: "Model",
        registerStatus: "Kayıt Durumu",
        password: "Şifre",
        passwordInfo: "Lütfen 6 ila 18 harf veya rakam girin!",
        group: "Grup",
        address: "Adres",
        remark: "Not",
        renewalPeriod: "Yenileme Süresi",
        money: "Ücret",
        latitudeInfo: "Lütfen doğru enlem girin!",
        totalPayment: "Toplam Tutar",
        longitudeInfo: "Lütfen doğru boylam girin!",
        setMeal: "Paket",
        number: "Adet",
        programName: "Program Adı",
        playStatus: "Oynatma Durumu",
        playType: "Oynatma Şekli",
        play: "Oynat",
        pause: "Duraklat",
        playTime: "Oynatma Zamanı",
        programDeleted: "Program silindi",
        playSuccess: "Program oynatma planlandı",
        pauseSuccess: "Duraklatma başarılı",
        playCycle: "Döngü Oynatma",
        playInsert: "Araya Gömme Oynatma",
        withdrawSuccess: "Geri Çekme başarılı",
        withdrawInfo: "Lütfen önce geri çekilecek programı seçin！",
        programBelong: "İlişkili Program",
        checkAll: "Tümünü Seç",
        batchDel: "Toplu Sil",
        delConfirm: "Seçilen öğeleri silmeyi onaylıyor musunuz？",
        check: "Seçildi",
        noProgram: "Program yok",
        details: "Detaylar",
        screenshotFail: "Ekran görüntüsü alma başarısız",
        policyName: "Politika Adı",
        terminalNum: "İlişkili Terminal Sayısı",
        powerStrategy: "Güç Stratejisi",
        pleaseSelectDepartment: "Lütfen departman seçin！",
        screenshotControl: "Ekran Görüntüsü Kontrolü",
        未激活: "Aktif Değil",
        已激活: "Aktif",
        未绑定: "Bağlanmadı",
        已绑定: "Bağlandı",
    },
    programManage: {
        programList: "Program Listesi",
        publishProgram: "Program Yayın İzleme",
        week1: "Pazartesi",
        week2: "Salı",
        week3: "Çarşamba",
        week4: "Perşembe",
        week5: "Cuma",
        week6: "Cumartesi",
        week7: "Pazar",
        monday: "Pazartesi",
        tuesday: "Salı",
        wednesday: "Çarşamba",
        thursday: "Perşembe",
        friday: "Cuma",
        saturday: "Cumartesi",
        sunday: "Pazar",
        name: "Adı",
        preview: "Önizleme",
        playDeviceNum: "Oynatma Cihaz Sayısı",
        copyDeviceCode: "Kopyalamak için tıklayın",
        osType: "Sistem Türü",
        playDate: "Oynatma Tarihi",
        playWeek: "Oynatma Haftası",
        everyday: "Her Gün",
        start: "Başlangıç",
        end: "Bitiş",
        playOperateStatusStr: "Yayın Durumu",
        playDevice: "Oynatma Cihazı",
        downloadView: "İndirmeyi Görüntüle",
        publisher: "Yayınlayan",
        publishTime: "Yayın Zamanı",
        operation: "İşlem",
        add: "Ekle",
        groupName: "Grup Adı",
        selectDevice: "Terminal Seç",
        searchDevice: "Terminal Ara",
        pleaseFillGroupName: "Lütfen grup adını doldurun！",
        remarkInfo: "Not",
        compile: "Düzenle",
        withdrawConfirm: "Bu programı geri çekmeyi onaylıyor musunuz？",
        confirm: "Onayla",
        cancel: "İptal",
        withdraw: "Geri Çek",
        batchWithdraw: "Toplu Geri Çek",
        batchPublish: "Toplu Yayınla",
        batchDelete: "Toplu Sil",
        batchOperation: "Toplu İşlem",
        notUse: "Kullanılmıyor",
        notChecked: "Onaylanmadı",
        notPass: "Onaylanmadı",
        delete: "Sil",
        publishTextLeft: "Yayınlandı",
        offTextLeft: "Duraklatıldı",
        pleaseSelectProgramToMove: "Lütfen taşınacak programı seçin！",
        pause: "Duraklat",
        pauseConfirm: "Duraklatmayı onaylıyor musunuz？",
        play: "Oynat",
        downloadUdisk: "USB Belleğe İndir",
        deviceList: "Cihaz Listesi",
        groupSelection: "Grup Seçimi",
        operationSuccess: "İşlem başarılı",
        deleteSuccess: "Silme başarılı",
        selectDate: "Tarih Seç",
        publishStatus: "Yayın Durumu",
        checkStatus: "Onay Durumu",
        waitAuditing: "Onay Bekliyor",
        auditPass: "Onaylandı",
        auditRefuse: "Reddedildi",
        all: "Tümü",
        playStatus: "Oynatılıyor",
        playStatust: "Oynatma Durumu",
        pauseStatus: "Duraklatıldı",
        notStartStatus: "Başlamadı",
        resolutionratio: "Çözünürlük",
        totalNum: "adet",
        programName: "Program Adı",
        playStartTime: "Oynatma Başlangıç Zamanı",
        playEndTime: "Oynatma Bitiş Zamanı",
        createTime: "Oluşturulma Zamanı",
        nationality: "Ulusallık",
        province: "İl",
        city: "İlçe",
        county: "Köy/Belde",
        address: "Adres",
        ip: "IP Adresi",
        location: "Konum",
        log: "Günlük",
        pleaseFillProgramName: "Lütfen program adını doldurun！",
        selectGroup: "Grup Seç",
        startTime: "Başlangıç Zamanı",
        endTime: "Bitiş Zamanı",
        publishCycle: "Yayın Döngüsü",
        publishDeviceNum: "Yayınlanan Cihaz Sayısı",
        pleaseSelectRecord: "Lütfen kayıt seçin",
        deviceName: "Terminal Adı",
        deviceId: "Terminal Cihaz ID",
        deviceGroupIdName: "İlişkili Grup",
        notClassified: "Sınıflandırılmamış",
        osTypeStr: "Terminal Sistemi",
        storageSpace: "Depolama Alanı",
        onLineStatus: "Çevrimiçi Durum",
        onLine: "Çevrimiçi",
        offLine: "Çevrimdışı",
        sleep: "Uyku Modunda",
        unknown: "Bilinmiyor",
        registerStatus: "Kayıt Durumu",
        trialPeriod: "Deneme Süresi",
        notActive: "Aktif Değil",
        active: "Aktif",
        parameterError: "Parametreler hatalı!",
        pleaseSelectProgram: "Lütfen program seçin!",
        pleaseSelectProgramEdit: "Lütfen düzenlenecek programı seçin!",
        confirmWithdrawSelectedProgram: "Seçilen programı geri çekmeyi onaylıyor musunuz？",
        withdrawSuccess: "Geri çekme başarılı",
        allPrograms: "Tüm Programlar",
        defaultGroup: "Varsayılan Grup",
        cannotShareEmptyProgram: "Boş program paylaşılamaz！",
        onlyShareYourProgram: "Sadece kendi oluşturduğunuz programları paylaşabilirsiniz!",
        pleaseSelectProgramEditPublishTime: "Lütfen yayın zamanı düzenlenmiş programı seçin!",
        pleaseSelectDevice: "Lütfen cihaz seçin!",
        programDetail: "Program Detayları",
        errorReason: "Hata Nedeni",
        availableStorageSpaceInsufficient: "Kullanılabilir depolama alanı yetersiz",
        partialDeviceReleaseFailure: "Kısmi cihaz yayınlama başarısız",
        allDeviceReleaseSuccess: "Tüm cihaz yayınlama başarılı",
        partialDeviceReleaseSuccess: "Kısmi cihaz yayınlama başarılı",
        allGroup: "Tüm Gruplar",
        allProgram: "Tüm Programlar",
        unGrouped: "Grupta Değil",
        replaceProgram: "Programı Değiştir",
        replaceProgramTip: "Yeni yayınlanan program, oynatma terminalindeki mevcut indirilmiş program verilerini değiştirecektir！",
        screen: "Tek/Çift Ekran",
        singleScreen: "Tek Ekran",
        doubleScreen: "Çift Ekran",
        playSetting: "Oynatma Ayarları",
        batchPlaySetting: "Toplu Oynatma Zamanı Ayarı",
        individualPlaySetting: "Tek Tek Oynatma Zamanı Ayarı",
        playTime: "Oynatma Zamanı",
        daily: "Her Gün",
        weekdays: "Pazartesi ile Cuma Arası",
        monthly: "Ay İçi",
        advancedSetting: "Gelişmiş Ayarlar",
        playProgram: "Programı Oynat",
        searchProgram: "Lütfen anahtar kelime girin",
        shareAddressNotExist: "Paylaşım bağlantısı bulunamadı, lütfen tekrar deneyin",
        copySuccess: "Kopyalama başarılı",
        shareLink: "Paylaşım Bağlantısı",
        publish: "Yayınla",
        noResource: "Kaynak yok",
        single: "Tek Ekran",
        double: "Çift Ekran",
        time: "Zaman",
        associatedTerminalNum: "İlişkili Terminal Sayısı",
        default: "Varsayılan",
        moveGroup: "Grubu Taşı",
        pleaseSelectGroup: "Lütfen grup adını doldurun！",
        copy: "Kopyala",
        FUBEN: "Kopya",
        nameempty: "Adı boş olamaz",
        whitespace: "Adlandırma hatası, dosya adında boşluk olamaz！",
        programWhitespace: "Adlandırma hatası, program adında boşluk olamaz！",
        pleaseSelectResolution: "Lütfen çözünürlük seçin！",
        dataError: "Veri hatalı！",
        createProgram: "Yeni Program Oluştur",
        directCreate: "Doğrudan Oluştur",
        myTemplate: "Şablonlarım",
        use: "Kullan",
        free: "Ücretsiz",
        loadMore: "Daha Fazlasını Yükle",
        confirmDelete: "Silmeyi onayla",
        deleteGroup: "Grubu Sil",
        notPublished: "Yayınlanmadı",
        notPassed: "Onaylanmadı",
        notUsed: "Kullanılmıyor",
        confirmDeleteSelectedProgram: "Seçilen programları silmeyi onaylıyor musunuz？",
        companyName: "Şirket Adı",
        programCannotDownload: "Bu program indirilemez！",
        publishMaterial: "Malzeme Yayınla",
        playMaterial: "Malzeme Oynat",
        pleaseInputMaterialName: "Lütfen malzeme adını girin",
        size: "Boyut",
        pleaseInputDeviceName: "Lütfen cihaz adını girin",
        item: "adet",
        allMaterial: "Tüm Malzemeler",
        allDevices: "Tüm Cihazlar",
        "saveSuccess": "Başarıyla kaydedildi",
        "savefaill": "Kaydetme başarısız",
        "playMode": "Oynatma modu",
        "cyclePlay": "Döngüsel oynatma",
        "insertPlay": "Eklenti oynatma",
        "noData": "Veri bulunmamaktadır",
        "Add": "Ekle",
        "replace": "Değiştir",
        "repeat": "Tekrarla",
        "start01": "Başla",
        "end01": "Bitir",
        "startDate": "Başlangıç tarihi",
        "endDate": "Bitiş tarihi",
        "useNow": "Hemen kullan",
        "fillStartEndTimeFirst": "Lütfen eklemeden önce başlangıç ve bitiş saatlerini doldurun",
        "fillFullPlayTime": "Lütfen tam oynatma süresini doldurun",
        "fillCorrectPlayTime": "Lütfen doğru oynatma periyodunu doldurun",
        "sDateAndEDateBothEmptyOrFilled": "Başlangıç tarihi ve bitiş tarihi hem boş hem de dolu olmalıdır"
    },
    source: {
        addResource: "Kaynak Ekle",
        width: "Genişlik",
        height: "Yükseklik",
        size: "Boyut(KB)",
        name: "Adı",
        pleaseInputResourceName: "Lütfen kaynak adını girin！",
        addToGroup: "Gruba Ekle",
        remark: "Not",
        promptFgIllustrate: "İllüstrasyon",
        promptFgRealisticPhoto: "Gerçekçi Fotoğraf",
        promptFgSimplisticDrawing: "Basit Çizim",
        promptFgChineseStyle: "Çin Tarzı",
        promptFgPixelArt: "Piksel Sanatı",
        noModel: "Model yok, lütfen yöneticinizle iletişime geçin！",
        getModelFailed: "Model alınamadı, lütfen daha sonra tekrar deneyin！Veya yöneticinizle iletişime geçin！",
        createImagePrompt: "Resim oluşturuluyor, lütfen daha sonra kapatın！",
        promptEmpty: "Lütfen ipucu metnini girin",
        dpiEmpty: "Lütfen resim oranını seçin！",
        fgEmpty: "Lütfen stil seçin！",
        style: "Stil",
        idEmpty: "Resim kimliği boş olamaz",
        exist: "Bu resim zaten malzeme içinde mevcut",
        addSuccess: "Malzeme ekleme başarılı",
        saveError: "Resim kaydedilemedi, lütfen daha sonra tekrar deneyin！",
        delSuccess: "Silme başarılı",
        generateImage: "Metinden Resim Oluştur",
        generateImagePlaceholder: 'Oluşturmak istediğiniz resmi girin, örn: bir kelebek çiçeklikte dans ediyor',
        aiExpand: "Akıllı Genişletme",
        negativePrompt: "Negatif İpucu Metni",
        negativePromptTooltip: "Kullanıcının çıktıda görmek istemediği içerikleri veya özellikleri açıkça hariç tutmak için kullanılır",
        imageRatio: "Resim Oranı",
        generateImageBtn: "Hemen Oluştur",
        shengchengjieguo: "Oluşturma Sonucu",
        generateImageLoadingTip: "Oluşturuluyor, lütfen tekrar tıklamayın veya kapatmayın...",
        Tooltip: "Yaratıcılığınızı AI ile keşfedin",
        saveToMaterial: "Malzemeye Kaydet",
        publish: "Hemen Yayınla",
        download: "İndir",
        generateHistory: "Oluşturma Geçmişi",
        hide: "Gizle",
        cancel: "İptal",
        useExpand: "Genişletmeyi Kullan",
        all: "Tümü",
        delete: "Sil",
        loadMore: "Daha Fazlasını Yükle",
        aiTip: "İçerik yapay zeka modeli tarafından oluşturulmuştur, platformun görüşünü, konumunu veya tutumunu temsil etmez, lütfen AI içeriğini makul ve uyumlu bir şekilde kullanın",
        operationSuccess: "İşlem başarılı",
        moveGroup: "Grubu Taşı",
        groupName: "Grup Adı",
        pleaseSelectGroup: "Lütfen grup adını seçin！",
        shenhe: "Onayla",
        shenheStatus: "Onay Durumu",
        shenheSuccess: "Onaylandı",
        shenheRefuse: "Reddedildi",
        pleaseSelectShenheStatus: "Lütfen onay durumunu seçin！",
        shenheRemark: "Onay Notu",
        pleaseInputShenheRemark: "Lütfen onay notunu girin！",
        pleaseInputFileName: "Lütfen dosya adını girin！",
        whitespace: "Adlandırma hatası, dosya adında boşluk olamaz！",
        dataError: "Veri hatalı！",
        confirmDelete: "Silmeyi onayla",
        confirm: "Onayla",
        deleteFolder: "Klasörü Sil",
        add: "Ekle",
        edit: "Düzenle",
        fileName: "Dosya Adı",
        group: "Grup",
        resolution: "Çözünürlük",
        type: "Tür",
        image: "Resim",
        music: "Müzik",
        video: "Video",
        uploadTime: "Yükleme Zamanı",
        uploadUser: "Yükleyen",
        checkTime: "Onay Zamanı",
        checkUser: "Onaylayan",
    },
    setting: {
        nameempty: "Adı boş olamaz",
        heightempty: "Yükseklik boş olamaz",
        widthempty: "Genişlik boş olamaz",
        resolutionratio: "Çözünürlük",
        name: "Adı",
        opteration: "İşlem",
        compile: "Düzenle",
        delete: "Sil",
        newz: "Yeni Ekle",
        compileratio: "Çözünürlüğü Düzenle",
        sheizhifenbianlvmingcheng: "Çözünürlük adını ayarla",
        shezhigaodu: "Yüksekliği ayarla",
        shezhikuandu: "Genişliği ayarla",
        xinzengfenbianlv: "Yeni çözünürlük ekle",
        bianma: "Kodlama",
        bianjizhongduanmingcheng: "Terminal adını düzenle",
        xinzengzhongduan: "Yeni terminal ekle",
        selectPrimaryColor: 'Tema rengini seçin',
        fullScreen: 'Tam Ekran',
        exitFullScreen: 'Tam Ekran Çık',
    },
    tabs: {
        refresh: 'Yenile',
        refreshAll: 'Tümünü Yenile',
        close: 'Kapat',
        closeOthers: 'Diğerlerini Kapat',
        closeAll: 'Tümünü Kapat',
        closeLeft: 'Soldakileri Kapat',
        closeRight: 'Sağdakileri Kapat',
    },
    errorPage: {
        needLogin: 'Henüz giriş yapmadınız！',
        pageNotFound: 'Eriştiğiniz sayfa bulunamadı！',
        redirectTo: 'Yönlendiriliyor',
        orReturn: 'veya geri dön',
        previousStep: 'Önceki Adım',
    },
    headerUs: {
        systemNotice: "Sistem Bildirimi",
        allNotices: "Tüm Bildirimler",
        viewAllMessages: "Tüm Mesajları Görüntüle",
        contactUs: "Bize Ulaşın",
        operationSuccess: "İşlem başarılı！",
        leaveMessage: "Mesaj Bırakmak İstiyorum",
        messageTitle: "Başlık",
        messageTitleTip: "Lütfen başlık girin！",
        messageContentTip: "Máximo 150 caracteres",
        submit: "Gönder",
        markAsRead: "Okunmuş Olarak İşaretle",
        success: "İşlem başarılı！"
    },
    material: {
        allMaterial: "Tüm Malzemeler",
        defaultGroup: "Varsayılan Grup",
        auditStatus: "Onay Durumu",
        auditPassed: "Onaylandı",
        auditRejected: "Reddedildi",
        pendingAudit: "Onay Bekliyor",
        all: "Tümü",
        operateSuccess: "İşlem başarılı！",
        pleaseSelectMaterial: "Lütfen malzeme seçin！",
        moveGroup: "Grubu Taşı",
        pleaseSelectGroup: "Lütfen grup seçin！",
        batchPublish: "Toplu Yayınla",
        batchRecall: "Toplu Geri Çek",
        batchDelete: "Toplu Sil",
        materialList: "Malzeme Listesi",
        uploadMaterial: "Malzeme Yükle",
        materialType: "Malzeme Türü",
        pleaseInputMaterialName: "Lütfen malzeme adını girin",
        selectAll: "Tümünü Seç",
        confirmDeleteSelectedMaterial: "Seçilen malzemeleri silmeyi onaylıyor musunuz？",
        deleteSuccess: "Silme başarılı",
        delete: "Sil",
        publish: "Yayınla",
        recall: "Geri Çek",
        confirmRecallSelectedMaterial: "Seçilen malzemeleri geri çekmeyi onaylıyor musunuz？",
        pleaseSelectMaterialGroup: "Lütfen malzeme grubunu seçin！",
        recallSuccess: "Geri çekme başarılı",
        publishSuccess: "Yayınlama başarılı",
        batchOperate: "Toplu İşlem",
        item: "adet",
        confirmDelete: "Silmeyi onaylıyor musunuz？",
        edit: "Düzenle",
        confirmRecall: "Geri çekmeyi onaylıyor musunuz？",
        unaudited: "Onaylanmadı",
        notPassed: "Onaylanmadı",
        operate: "İşlem",
        resolution: "Çözünürlük",
        none: "Yok",
        confirm: 'Onayla',
        cancel: 'İptal',
        AICreation: "AI Oluşturma",
    },
    uploadFile: {
        operationSuccess: "İşlem başarılı",
        uploadFile: "Yükleme Yönetimi",
        uploadSuccess: "Yükleme başarılı",
        uploadCompleted: "Yükleme tamamlandı",
        uploadFail: "Yükleme başarısız",
        ConversionFailed: "Dönüştürme başarısız！",
        loading: "Yükleniyor...",
        beQueuing: "Sırada...",
        Uploading: "Yükleniyor...",
        ConversionIng: "Dönüştürülüyor...",
        ConventionalResources: "Geleneksel Kaynaklar",
        DocumentResources: "Belge Kaynakları",
        complete: "Tamamlandı",
        upload: "Yükle",
        fileSizeWraning01: "Malzeme boyutu aştı",
        fileSizeWraning02: "Lütfen değiştirip tekrar yükleyin！",
        fileIsEmpty: "Dosya boş",
        uploadFileTip: "Desteklenmeyen dosya formatı",
        unablePreview: "Malzeme kütüphanesine başarıyla eklenmedi, önizleme yapılamaz",
        confirmDelete: "Silmeyi onaylıyor musunuz？",
        deleteSuccess: "Silme başarılı",
        delete: "Sil",
        confirm: "Onayla",
        preview: "Önizleme",
        close: "Kapat",
        cancel: "İptal",
        fileType: "Dosya Türü",
        fileSize: "Dosya Boyutu",
        conversionProgress: "Dönüştürme İlerleme Durumu",
        progress: "İlerleme",
        image: "Resim",
        video: "Video",
        audio: "Müzik",
        limitTip01: "Bir seferde yükleme",
        limitTip02: "adet dosya",
        okTip: "Malzeme yükleniyor, lütfen daha sonra kapatın！",
        usableSize: 'Kullanılabilir Kapasite',
        sizeUnableTip: "Mevcut kullanılabilir depolama alanı yetersiz, lütfen gereksiz malzemeleri zamanında temizleyerek alan kazanın veya bayinizle iletişime geçerek bulut depolama alanı genişletme hizmeti alın.",
        view: "Detayları Görüntüle",
        fileName: "Dosya Adı",
    },
    template: {
        inputPlaceholder: 'Lütfen girin',
        selectPlaceholder: 'Lütfen seçin',
        noAuths: "Yetkiniz yok, lütfen yöneticinizle iletişime geçin",
        operationSuccess: "İşlem başarılı",
        total: "Toplam",
        totalNum: "adet",
        dan: "Tek",
        shaung: "Çift",
        pleaseSelectGroup: "Lütfen grup seçin",
        preview: "Önizleme",
        free: "Ücretsiz",
        use: "Kullan",
        dpi: 'Çözünürlük',
        delete: "Sil",
        confirmDelete: "Silmeyi onayla",
        confirmDeleteSelectedTemplate: "Bu şablonu silmeyi onaylıyor musunuz",
        push: "Yayınla",
        pushConfirm: "Genel şablona yayınlamayı onaylıyor musunuz",
        pushRemovalConfirm: "Genel şablondan kaldırmayı onaylıyor musunuz",
        templateOrderRecord: "Şablon Sipariş Kaydı",
        unpublished: "Yayınlanmadı",
        auditing: "Onaylanıyor",
        publishRejected: "Yayın Reddedildi",
        publishSuccess: "Yayınlama Başarılı",
        offShelf: "Satıştan Kaldır",
        公共模版: "Genel Şablon",
        我的模板: "Şablonlarım",
        共享记录: "Paylaşım Kaydı",
        name: "Adı",
        pubdate: "Yayın Zamanı",
        keySeachTip: "Lütfen anahtar kelime girin",
        allGroup: "Tüm Gruplar",
        add: "Ekle",
        edit: "Düzenle",
        programName: "Program Adı",
        selectGroup: "Grup Seç",
    },
    checkManage: {
        total: "Toplam",
        totalNum: "adet",
        operationSuccess: "İşlem başarılı",
        checkUserLogs: "Onay Kaydı (Operatör)",
        checkLogs: "Onay Kaydı (Onaycı)",
        sourceCheck: "Malzeme Onayı",
        programCheck: "Program Onayı",
        checkAll: "Tümünü Seç",
        auditPass: "Onaylandı",
        auditRefuse: "Reddedildi",
        auditPass01: "Onaylandı",
        auditRefuse01: "Reddedildi",
        auditRefuse02: "Onay Reddet",
        auditor: "Onaylayan",
        agentUserName: "Yayınlayan",
        interrogationTime: "İnceleme Zamanı",
        checkTime: "Onay Zamanı",
        checkName: "Onay Adı",
        checkType: "Onay Kategorisi",
        checkIp: "İnceleme IP Adresi",
        checkReason: "Mesaj",
        checkStatus: "İşlem İçeriği",
        rangePicker: "Onay Tarihi",
        keyWord: "Anahtar Kelime",
        all: "Tümü",
        program: 'Program',
        material: 'Malzeme',
        dan: "Tek",
        shaung: "Çift",
        pleaseSelectProgram: "Lütfen program seçin!",
        pleaseSelectMaterial: "Lütfen malzeme seçin！",
        preview: "Önizleme",
        dpi: 'Çözünürlük',
        auditRefuseTip: "Lütfen reddetme nedenini girin",
        unreviewed: "Onaylanmadı",
        notPassed: "Onaylanmadı",
        notUsed: "Kullanılmıyor",
        edit: "Düzenle",
        none: "Yok",
        name: "Adı",
        size: "Boyut",
        type: "Tür",
        uploadTime: "Yükleme Zamanı",
        uploadUser: "Yükleyen",
        checkUser: "Onaylayan",
        image: "Resim",
        music: "Müzik",
        video: "Video",
    },
    systemSet: {
        total: "Toplam",
        totalNum: "adet",
        inputPlaceholder: 'Lütfen girin',
        selectPlaceholder: 'Lütfen seçin',
        userList: "Organizasyon Üyeleri",
        roleList: "Rol Yetkileri",
        department: "Organizasyon Yapısı",
        diskInfo: "Depolama Alanı",
        approveSet: "İçerik Onayı",
        logList: "Günlük Yönetimi",
        name: "Adı",
        account: "Hesap",
        userName: "Kullanıcı Adı",
        phoneNumber: "Cep Telefonu Numarası",
        role: "Rol",
        createTime: "Oluşturulma Zamanı",
        operation: "İşlem",
        edit: "Düzenle",
        delete: "Sil",
        addNew: "Yeni Ekle",
        add: "Ekle",
        resetPassword: "Şifreyi Sıfırla",
        confirmDelete: "Silmeyi onayla",
        departmentOrganization: "Departman Kurumu",
        addNewUser: "Yeni Kullanıcı Ekle",
        pleaseEnterUserName: "Lütfen kullanıcı adını girin",
        confirmPasswordNotMatch: "Onay şifresi şifre ile uyuşmuyor!",
        operationSuccess: "İşlem başarılı！",
        userNickname: "Kullanıcı Adı",
        pleaseEnterUserNickname: "Lütfen kullanıcı adını girin",
        userNicknameRequired: "Kullanıcı adı boş olamaz！",
        password: "Şifre",
        pleaseEnterPassword: "Lütfen şifre girin",
        passwordRequired: "Şifre boş olamaz！",
        passwordTip: "Şifrenizin güvenlik seviyesi çok düşük (şifre büyük harf, küçük harf, rakam, özel karakterlerden herhangi üçünü içermeli ve uzunluk 8",
        confirmPassword: "Şifreyi Onayla",
        pleaseEnterPhoneNumber: "Lütfen cep telefonu numarasını girin",
        phoneNumberRequired: "Cep telefonu numarası boş olamaz！",
        phoneNumberFormatError: "Lütfen doğru cep telefonu numarası girin！",
        roleRequired: "Rol boş olamaz！",
        required: "Boş olamaz！",
        departmentName: "Departman",
        modifyPassword: "Şifreyi Değiştir",
        newPassword: "Yeni Şifre",
        pleaseEnterNewPassword: "Lütfen yeni şifre girin",
        pwdMessage: "Şifre 8~20 karakter uzunluğunda olmalıdır, boşluk içermemeli ve büyük harf, küçük harf, rakam, özel karakterlerden üçünü içermelidir",
        all: "Tümü",
        noAuths: "Yetkiniz yok, lütfen yöneticinizle iletişime geçin",
        departmentName01: "Departman Adı",
        image: "Resim",
        music: "Müzik",
        video: "Video",
        buySize: "Satın Alma Miktarı",
        totalMoney: "Toplam Tutar",
        buycreateTime: "Satın Alma Zamanı",
        endTime: "Bitiş Zamanı",
        buyTypeStr: "Sipariş Türü",
        sourceCheck: "Malzeme Onayı",
        programCheck: "Program Onayı",
        programName: "Program Adı",
        diskExpansion: "Kullanım süresince sürekli olarak süresi dolmuş/kullanılmayan malzemeleri temizlemeniz önerilir, böylece sistemin kullanılabilir kapasitesi garanti edilir. Daha büyük alan ihtiyacınız varsa, cihaz tedarikçinizle iletişime geçerek bulut depolama alanı genişletme hizmeti alabilirsiniz. Bu hizmet ücretli olabilir, detaylar için bayinizle iletişime geçiniz.",
        selectPermission: "Lütfen yetki seçin",
        checkPermission: "Lütfen yetkiyi onaylayın",
        addRole: "Rol Ekle",
        enterRoleName: "Lütfen rol adını girin",
        roleName: "Rol Adı",
        roleNameRequired: "Rol adı boş olamaz！",
        remark: "Not",
        enterRemark: "Lütfen not girin",
        permissionSetting: "Yetki Ayarları",
        deleteSuccess: "Silme başarılı！",
        confirmToDelete: "Silmeyi onaylıyor musunuz？",
        orgName: "Kurum Adı",
        orgNameRequired: "Kurum adı boş olamaz！",
        orgRemark: "Kurum Notu",
        enterOrgRemark: "Lütfen kurum notunu girin",
        capacityUsage: "Kapasite Kullanım Durumu",
        usedCapacity: "Kullanılan Kapasite",
        totalCapacity: "Toplam Kapasite",
        remainingCapacity: "Kalan Kapasite",
        capacityExpansion: "Kapasite Genişletme",
        enable: "Etkinleştir",
        disable: "Devre Dışı Bırak",
        userName01: "Kullanıcı Adı",
        loginTime: "Giriş Zamanı",
        ipAddress: "IP Adresi",
        loginResult: "Giriş Sonucu",
        selectDate: "Tarih Seç",
        enterDate: "Lütfen tarih seçin",
        selectStartTime: "Lütfen başlangıç zamanını seçin",
        selectEndTime: "Lütfen bitiş zamanını seçin",
        enterUserName: "Lütfen kullanıcı adını girin",
        userCount: "Kullanıcı Sayısı",
        roleDesc: "Rol Açıklaması",
        roleAuthorization: "Rol Yetkilendirme",
        success: "Başarılı",
        failure: "Başarısız",
        time: "Zaman",
        operationContent: "İşlem İçeriği",
        playCount: "Oynatma Sayısı",
        playDuration: "Oynatma Süresi",
        selectDevice: "Cihaz Seç",
        enterProgramName: "Lütfen program adını girin",
        serialNumber: "Sıra Numarası",
        publishContentName: "Yayınlanan İçerik Adı",
        playMode: "Oynatma Şekli",
        cyclePlay: "Döngü Oynatma",
        insertPlay: "Araya Gömme Oynatma",
        paddingPlay: "Doldurma Oynatma",
        playDeviceId: "Oynatma Cihaz ID",
        playDeviceName: "Oynatma Cihaz Adı",
        publishTime: "Yayın Zamanı",
        downloadStatus: "İndirme Durumu",
        notDownloaded: "İndirilmedi",
        downloading: "İndiriliyor",
        downloadSucceeded: "İndirme Başarılı",
        downloadFailed: "İndirme Başarısız",
        enterPublishContentName: "Lütfen yayınlanan içerik adını girin",
        terminalId: "Terminal ID",
        belongOrg: "İlişkili Kurum",
        reportTime: "Bildirim Zamanı",
        reportIp: "Bildirim IP",
        logInfo: "Günlük Bilgisi",
        details: "Detaylar",
        confirmDeletion: "Silmeyi onaylıyor musunuz？",
        logDetails: "Günlük Detayları",
        download: "İndir",
        deptOrg: "Departman Kurumu",
        query: "Sorgula",
        queryByTerminalId: "Terminal ID'ye Göre Sorgula",
        batchDeleteLogs: "Toplu Günlük Silme",
        customTimeDeleteLogs: "Özel Zaman Aralığı ile Günlük Silme",
        selectTimeRangeFirst: "Lütfen önce zaman aralığını seçin",
        deleteAllDeviceLogsIfEmpty: "Cihaz ID girilmezse, varsayılan olarak tüm cihazların günlükleri silinir",
        enterDeviceIdToDeleteLogs: "Lütfen günlükleri silinecek cihaz ID'sini girin",
        confirmDeleteAction: "Silmeyi Onayla",
        selectDeleteRangeFirst: "Lütfen önce silme aralığını seçin",
        networkConnectionFailed: "Ağ bağlantısı başarısız",
        playLog: "Oynatma Günlüğü",
        publishLog: "Yayın Günlüğü",
        errorLog: "Hata Günlüğü",
        operationLog: "İşlem Günlüğü",
        fileLog: "Dosya Günlüğü",
        userOperateLog: "Giriş Günlüğü",
    },
    userManual: {
        userManual: "Kullanıcı Kılavuzu",
        noData: "Veri yok",
    },
    systemNotice: {
        systemNotice: "Sistem Bildirimi",
        noData: "Veri yok",
        total: "Toplam",
        totalNum: "adet",
        "markAllRead": "Tümünü Okunmuş Olarak İşaretle",
        "deleteAll": "Tümünü Sil",
        "all": "Tümü",
        "unread": "Okunmadı",
        "read": "Okundu",
        "type": "Tür",
        "content": "İçerik",
        "date": "Tarih",
        "status": "Durum",
        "confirmDelete": "Silmeyi onaylıyor musunuz？",
        "confirm": "Onayla",
        "cancel": "İptal",
        "delete": "Sil"
    }
};